import script from "./side-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-menu.vue?vue&type=script&setup=true&lang=ts"

import "./side-menu.vue?vue&type=style&index=0&id=7d99a3ca&lang=scss"

const __exports__ = script;

export default __exports__